import { createSaveInProgressFormReducer } from 'platform/forms/save-in-progress/reducers';
import formConfig from '../config/form';
import { champvaEnrollmentStatusReducer } from './enrollmentStatus';

export default {
  form: createSaveInProgressFormReducer(formConfig),
  champvaEnrollmentStatus: champvaEnrollmentStatusReducer,
};
